import React from "react";
// import * as FaIcons from "react-icons/fa";
import { AiFillHome, AiOutlineApartment } from "react-icons/ai";
import { BiCalendar } from "react-icons/bi";
import { BsDot, BsPerson } from "react-icons/bs";
import { FaCalendarCheck, FaHospital, FaUserNurse } from "react-icons/fa";
import { FiAirplay, FiCreditCard, FiLayers } from "react-icons/fi";
import { GrDocumentCloud } from "react-icons/gr";
import { MdEditCalendar } from "react-icons/md";
import { TbChartHistogram, TbHistory, TbTemplate } from "react-icons/tb";

export const IconSelector = (props) => {
  if (!props.iconname) return <AiFillHome />;
  switch (props?.iconname) {
    case "ai_fill_home":
      return <AiFillHome {...props} />;

    case "ai_outline_apartment":
      return <AiOutlineApartment {...props} />;

    case "bs_dot":
      return <BsDot {...props} />;

    case "work-list":
      return <FiAirplay {...props} />;

    case "physician":
      return <FaUserNurse {...props} />;

    case "hospital":
      return <FaHospital {...props} />;

    case "pat-right":
      return <FiCreditCard {...props} />;

    case "docu-report":
      return <BiCalendar {...props} />;

    case "bs_person":
      return <BsPerson {...props} />;

    case "pat-appoint":
      return <FaCalendarCheck {...props} />;

    case "rad-work-list":
      return <FiLayers {...props} />;

    case "rad-template":
      return <TbTemplate {...props} />;

    case "rad-history":
      return <TbHistory {...props} />;
    default:
      return <AiFillHome {...props} />;
  }
};
